.btn-scroll-to-top {
  display: none;
  position: fixed;
  bottom: 0px;
  right: 33px;
  height: 26px;
  width: 108px;
  border: solid 1px $secondary;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-color: $secondary;
  color: #FFFFFF;
  transform: translateY(0);
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.16);
  @include transitionDefault(all);
  z-index: $zindex-fixed;
  padding: 5px 10px 5px 11px;

  .scroll-btn-label {
    @include text-size(14);
    @include line-height(22);
    font-weight: 400;
    margin-left: -15px;
    position: absolute;
    left: 25px;
    top: 3px;
  }

  .svg-icon {
    position: absolute;
    right: 6px;
    top: 0;

    svg {
      @include svg-format(11px, 13px, #FFFFFF);
      @include transitionDefault(fill);
    }
  }

  &:hover,
  &:focus {
    padding-bottom: 7px;
    min-height: 28px;
  }
}